module.exports = __webpack_public_path__ + "img/LATAM_WHOLE_GRAINS.7df4aa2d.png";